import { render, staticRenderFns } from "./IconsSettings.vue?vue&type=template&id=465c6f52&scoped=true&"
import script from "./IconsSettings.vue?vue&type=script&lang=js&"
export * from "./IconsSettings.vue?vue&type=script&lang=js&"
import style0 from "./IconsSettings.vue?vue&type=style&index=0&id=465c6f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465c6f52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
